import { Directive, Input, Output, EventEmitter, HostListener, HostBinding } from '@angular/core';

/**
 * * Direção da ordenação.
 */
export type SortDirection = 'asc' | 'desc' | '';
const rotate: {[key: string]: SortDirection} = { asc: 'desc', desc: '', '': 'asc' };

/**
 * * Evento da Ordenação.
 */
export interface SortEvent {
  column: string;
  direction: SortDirection;
}

/**
 * * Diretiva para utilizar um elemento de ordenação em um cabeçalho de uma tabela.
 */
@Directive({
  selector: 'th[appSortable]'
})
export class SortableHeaderDirective {

  @Input() appSortable: string = '';
  /**
   * * Direcionamento da ordenação.
   */
  @Input() direction: SortDirection = '';
  /**
   * * Função de Evento de ordenação.
   */
  @Output() sort = new EventEmitter<SortEvent>();

  @HostBinding('class.asc') asc = this.direction === 'asc';
  @HostBinding('class.desc') desc = this.direction === 'desc';

  @HostListener('click')
  rotate() {
    this.direction = rotate[this.direction];
    this.updateDirection();
    this.sort.emit({column: this.appSortable, direction: this.direction});
  }

  updateDirection() {
    this.asc = this.direction === 'asc';
    this.desc = this.direction === 'desc';
  }

}
